// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"dc0f9d19","453":"1f2494e5"}[chunkId] + ".chunk.js";
};